import React from 'react'
import { Box, Grid, TextField } from '@mui/material'
import boxStyle from '../../styles/boxStyle'

function Vehicle({vehicleDetail}) {
  return (
    <Box sx={boxStyle.root} >
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Registration Number"
          variant="outlined"
          required
          name='owner'
          value={vehicleDetail?.VRM? vehicleDetail?.VRM :''}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          size='small'
          label="Vehicle Make Number"
          variant="outlined"
          required
          name='street'
          value={vehicleDetail?.Make? vehicleDetail?.Make :''}
        />
      </Grid>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Vehicle Model"
          variant="outlined"
          required
          name='post'
          value={vehicleDetail?.Model? vehicleDetail?.Model :''}
        />
      </Grid>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Engine Power"
          variant="outlined"
          required
          name='address'
          value={vehicleDetail?.Engine_power? vehicleDetail?.Engine_power :''}
        />
      </Grid>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Fuel Type"
          variant="outlined"
          required
          name='email'
          value={vehicleDetail?.Fuel_type? vehicleDetail?.Fuel_type :''}
        />
      </Grid>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Vehicle Description"
          variant="outlined"
          required
          name='mobile'
          value={vehicleDetail?.Vehicle_Description? vehicleDetail?.Vehicle_Description :''}
        />
      </Grid>
    </Grid>
  </Box>
  )
}

export default Vehicle